
define('text!TescoMobile_Customer/template/account/dashboard/bill-cap.html',[],function () { return '<!-- ko if: billCap().current_bill_cap --> <span><!-- ko i18n: \'Safety buffer: \' --><!-- /ko --></span> <strong data-bind="text: billCap().current_bill_cap, mageInit: {\'hideSkeletonLoading\':{}}"></strong><!-- /ko -->';});

